"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Mail, Phone } from "lucide-react";
export default function ContactoHero() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="contacto-hero" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center transform scale-110 transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
        backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548683/img/contact_hero_cityscape_blur.png)",
        filter: "blur(8px)"
      }} />
        {}
        <div className="absolute inset-0 bg-secondary/30" />
      </div>

      {}
      <div ref={heroRef} className="relative z-10 container mx-auto px-4 text-center max-w-4xl">
        {}
        <h1 className={`font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight leading-[1.1] transition-all duration-[var(--duration-medium)] ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        textShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
      }}>
          Conecta con LUMIÈRE
        </h1>

        {}
        <p className={`text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto font-sans transition-all duration-[var(--duration-medium)] delay-100 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)"
      }}>
          Estamos aquí para ayudarte con cualquier consulta sobre nuestras
          colecciones, servicios o asesoría personalizada.
        </p>

        {}
        <div className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-[var(--duration-medium)] delay-200 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Button asChild size="lg" className="bg-accent hover:bg-accent-hover text-foreground-accent font-medium px-8 py-6 rounded-md border-2 border-accent hover:border-accent-dark hover:shadow-[0_0_20px_rgba(205,164,60,0.3)] transition-all duration-[var(--duration-fast)] hover:scale-[1.02] active:scale-[0.98]">
            <Link to="#contacto-hero">
              <Mail className="size-5" />
              Envíanos un Mensaje
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 hover:bg-white/20 hover:border-white/50 px-8 py-6 rounded-md hover:shadow-[0_0_16px_rgba(255,255,255,0.2)] transition-all duration-[var(--duration-fast)] hover:scale-[1.02] active:scale-[0.98]">
            <Link to="tel:+525567891011">
              <Phone className="size-5" />
              +52 55 6789 1011
            </Link>
          </Button>
        </div>

        {}
        <div className={`mt-12 flex flex-wrap gap-4 justify-center transition-all duration-[var(--duration-medium)] delay-300 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="glass-effect px-6 py-3 text-white/90 text-sm font-sans">
            <span className="font-medium">Email:</span> contacto@lumiereboutique.mx
          </div>
          <div className="glass-effect px-6 py-3 text-white/90 text-sm font-sans">
            <span className="font-medium">Horario:</span> Lunes a Sábado: 10am - 8pm
          </div>
        </div>
      </div>
    </section>;
}